import { render } from "./ModalControl.vue?vue&type=template&id=3f7287f1"
import script from "./ModalControl.vue?vue&type=script&lang=js"
export * from "./ModalControl.vue?vue&type=script&lang=js"

import "./ModalControl.vue?vue&type=style&index=0&id=3f7287f1&lang=css"

import exportComponent from "C:\\Mobile\\registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__